import React, { useState } from 'react';
import { tryStaffUnlock } from '../utils/staffUnlock';

function StaffUnlock({ bookingId, onUnlock }) {
    const [open, setOpen] = useState(false);
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (tryStaffUnlock(bookingId, password)) {
            setError('');
            onUnlock();
        } else {
            setError('Incorrect password.');
        }
    };

    return (
        <div style={{ marginTop: '25px', paddingTop: '15px', borderTop: '1px solid #eee' }}>
            {!open ? (
                <button
                    id="staff-unlock-toggle"
                    type="button"
                    onClick={() => setOpen(true)}
                    style={{ background: 'none', border: 'none', color: '#0056b3', fontSize: '0.9em', cursor: 'pointer', textDecoration: 'underline' }}
                >
                    I am an IMA employee
                </button>
            ) : (
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                    <label htmlFor="staff-unlock-password" style={{ color: '#555', fontSize: '0.95em' }}>
                        Enter staff password to unlock this link
                    </label>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <input
                            id="staff-unlock-password"
                            type="password"
                            autoFocus
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={{ padding: '8px 10px', border: '1px solid #ccc', borderRadius: '4px' }}
                        />
                        <button
                            id="staff-unlock-submit"
                            type="submit"
                            style={{ padding: '8px 16px', border: 'none', borderRadius: '4px', backgroundColor: '#0056b3', color: '#fff', cursor: 'pointer' }}
                        >
                            Unlock
                        </button>
                    </div>
                    {error && <p role="alert" style={{ color: '#d9534f', margin: 0, fontSize: '0.9em' }}>{error}</p>}
                </form>
            )}
        </div>
    );
}

export default StaffUnlock;
